import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstatePropStats } from 'redux/realEstateSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonClose from 'utils/buttons/ButtonClose';
import ButtonDelete from 'utils/buttons/ButtonDelete';

const DeleteModal = ({ property, setShow, handleStatus }) => {
  const modalRef = useRef(null);
  const cancelButtonRef = useRef(null);
  const handleClose = () => setShow(false);

  const { realEstate } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();

  const handleDelete = async prop => {
    await handleStatus(prop);
    dispatch(getRealEstatePropStats(realEstate.id));
    handleClose();
  };

  useEffect(() => {
    setTimeout(() => {
      if (cancelButtonRef.current) {
        cancelButtonRef.current.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }
    }, 0);
  }, [cancelButtonRef]);
  return (
    <Modal
      ref={modalRef} // Asignar la referencia al modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon="fa-trash-can"
          title="Eliminar"
          size="1x"
          style={{ marginRight: 8, color: '#e63757' }}
        />
        <Modal.Title>Eliminar propiedad</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ overflowY: 'auto' }}>
        <div style={{ maxHeight: '50vh' }}>
          <div className="mb-4">
            La propiedad de dirección{' '}
            <b>
              {property.location.street} {property.location.number}
            </b>{' '}
            se eliminará, lo que la marcará como operación no concretada y los
            clientes no podrán verla.
            <br />
            <br />
            ¿Está seguro de confirmar esta acción?
          </div>
        </div>

        <ModalButtonsContainer>
          <ButtonClose
            ref={cancelButtonRef}
            text="Cancelar"
            funcion={handleClose}
            variant="secondary"
          />

          <ButtonDelete
            text="Eliminar"
            funcion={handleDelete}
            data={{ id: property._id, status: 'deleted' }}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

DeleteModal.propTypes = {
  property: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired
};

export default DeleteModal;
